let inited = false;
let logged;

module.exports = (rule, _logged = false) => {
	logged = _logged;

	if (!inited) {
		rule.pm.handleEvent('~.Pager_Simple', 'inited', (params, widget) => {
			let guestTplName = widget.getOption('tpl.container');
			let guestPagesCount = widget.getOption('pagesCount');

			if (widget.getOption('logged.tpl.container')) {
				widget.removeOption('tpl.container');

				Object.defineProperty(widget.options.tpl, 'container', {
					enumerable: true,
					get: () => {
						return logged ? widget.getOption('logged.tpl.container') : guestTplName;
					}
				});

				widget.addHook(() => delete widget.row, 'onStartRendering');
			}

			if (widget.getOption('logged.pagesCount')) {
				widget.removeOption('pagesCount');

				Object.defineProperty(widget.options, 'pagesCount', {
					enumerable: true,
					get: () => {
						return logged ? widget.getOption('logged.pagesCount') : guestPagesCount;
					}
				});
			}
		}, {
			prefix: 'rule_pagersimple_template',
			sync: true
		});
		
		inited = true;
	}
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/rules/common/register-pager-simple-tpls.es.js